/** Overrides mode nuit — Flux de marché, Leaders, cartes td-* (aligné accueil Capital) */
export const MARKET_PAGE_DARK_CSS = `
html[data-theme="dark"]{
  --bg:#000000;
  --app-bg:#000000;
  --paper:rgba(15,23,42,.92);
  --paper-alt:rgba(22,35,28,.88);
  --ink:#e8ede9;
  --ink2:#cbd5ce;
  --muted:#94a3b8;
  --line:rgba(148,163,184,.22);
  --line2:rgba(148,163,184,.10);
  --shadow:0 10px 30px rgba(0,0,0,.5);
  --row-h:rgba(181,154,91,.10);
}

html[data-theme="dark"] body{
  background:#000000 !important;
  color:var(--ink);
}

html[data-theme="dark"] .td-card,
html[data-theme="dark"] .td-tableCard,
html[data-theme="dark"] .td-trendBox{
  background:var(--paper) !important;
  border-color:var(--line) !important;
  box-shadow:var(--shadow) !important;
}

html[data-theme="dark"] .td-chartBox,
html[data-theme="dark"] .td-styleRow,
html[data-theme="dark"] .td-styleViz,
html[data-theme="dark"] .td-map,
html[data-theme="dark"] .td-trendTableWrap,
html[data-theme="dark"] .td-miniSelect,
html[data-theme="dark"] .td-ghostBtn,
html[data-theme="dark"] .td-modal{
  background:var(--paper-alt) !important;
  border-color:var(--line) !important;
}

html[data-theme="dark"] .td-mapWrap{
  background:radial-gradient(700px 260px at 50% 40%, rgba(181,154,91,.08), transparent 65%) !important;
  border-color:var(--line) !important;
}

html[data-theme="dark"] .td-styleViz{
  background:radial-gradient(220px 180px at 50% 45%, rgba(111,138,91,.14), rgba(181,154,91,.06) 55%, rgba(15,23,42,.95) 72%) !important;
}

html[data-theme="dark"] .td-row{
  border-color:var(--line) !important;
  background:var(--paper-alt) !important;
}

html[data-theme="dark"] .td-row-wrap:hover .td-row{
  background:var(--row-h) !important;
}

html[data-theme="dark"] .td-rowLabel,
html[data-theme="dark"] .td-styleName,
html[data-theme="dark"] .td-stylePct,
html[data-theme="dark"] .td-cardTitle h2,
html[data-theme="dark"] .td-trendTitle{
  color:var(--ink) !important;
}

html[data-theme="dark"] .td-rowVal:not(.td-val-pos):not(.td-val-neg){
  color:var(--ink) !important;
}

html[data-theme="dark"] .td-val-pos{
  color:#8fb878 !important;
}

html[data-theme="dark"] .td-val-neg{
  color:#e07a6a !important;
}

html[data-theme="dark"] .td-rowHeaderLabel,
html[data-theme="dark"] .td-rowHeaderVal,
html[data-theme="dark"] .td-rowHeaderPill,
html[data-theme="dark"] .td-styleHeaderLabel,
html[data-theme="dark"] .td-styleHeaderPct,
html[data-theme="dark"] .td-styleHeaderDelta,
html[data-theme="dark"] .td-cardSub,
html[data-theme="dark"] .td-trendMeta{
  color:var(--muted) !important;
}

html[data-theme="dark"] .td-rowPill{
  display:flex !important;
  align-items:center !important;
  justify-content:center !important;
  gap:6px !important;
  padding:6px 10px !important;
  border-radius:10px !important;
  font-weight:950 !important;
  border:1px solid var(--line) !important;
}

html[data-theme="dark"] .td-rowPill:not(.td-rowPill--bp):not(.td-flow-pill){
  background:rgba(181,154,91,.08) !important;
  color:var(--ink) !important;
}

html[data-theme="dark"] .td-rowPill.td-rowPill--bp{
  color:#fff !important;
  border-color:rgba(148,163,184,.25) !important;
}

html[data-theme="dark"] .td-flow-pill.flow-accum{
  background:#6f8a5b !important;
  border-color:rgba(111,138,91,.55) !important;
  color:#fff !important;
}

html[data-theme="dark"] .td-flow-pill.flow-distrib{
  background:#c6523f !important;
  border-color:rgba(198,82,63,.55) !important;
  color:#fff !important;
}

html[data-theme="dark"] .td-flow-pill.flow-rot-sell{
  background:#caa85e !important;
  border-color:rgba(202,168,94,.5) !important;
  color:#fff !important;
}

html[data-theme="dark"] .td-flow-pill.flow-rot-buy{
  background:#6f8a5b !important;
  border-color:rgba(111,138,91,.45) !important;
  color:#e8ede9 !important;
}

html[data-theme="dark"] .td-flow-pill.flow-neutral{
  background:#9a8b6e !important;
  border-color:rgba(154,139,110,.45) !important;
  color:#fff !important;
}

html[data-theme="dark"] .td-rowPill.strong{
  border-color:rgba(111,138,91,.55) !important;
  background:linear-gradient(135deg, rgba(111,138,91,.92), rgba(141,165,122,.86)) !important;
  color:#fff !important;
}

html[data-theme="dark"] .td-rowPill.moderate{
  border-color:rgba(202,168,94,.5) !important;
  background:linear-gradient(135deg, rgba(202,168,94,.92), rgba(181,154,91,.82)) !important;
  color:#fff !important;
}

html[data-theme="dark"] .td-rowPill.outflow{
  border-color:rgba(198,82,63,.5) !important;
  background:linear-gradient(135deg, rgba(198,82,63,.92), rgba(210,138,82,.78)) !important;
  color:#fff !important;
}

html[data-theme="dark"] .td-country-chip{
  background:var(--paper-alt) !important;
  border:1px solid var(--line) !important;
  color:var(--ink) !important;
}

html[data-theme="dark"] .td-country-chip .td-country-chip-muted{
  color:var(--muted) !important;
}

html[data-theme="dark"] .td-chip{
  background:rgba(181,154,91,.12) !important;
  border-color:var(--line) !important;
}

html[data-theme="dark"] .td-chip span{
  color:var(--ink) !important;
}

html[data-theme="dark"] .td-select{
  background-color:var(--paper-alt) !important;
  border-color:var(--line) !important;
  color:var(--ink) !important;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23e2e8f0' d='M6 8L0 0h12z'/%3E%3C/svg%3E") !important;
  background-repeat:no-repeat !important;
  background-position:right 12px center !important;
  background-size:12px 8px !important;
}

html[data-theme="dark"] .td-narrative-card{
  background:var(--paper) !important;
  border-color:var(--line) !important;
  color:var(--ink) !important;
  box-shadow:var(--shadow) !important;
}

html[data-theme="dark"] .td-seeMoreBtn{
  background:rgba(181,154,91,.14) !important;
  border-color:rgba(181,154,91,.35) !important;
  color:#d4b87a !important;
}

html[data-theme="dark"] .recharts-cartesian-grid line,
html[data-theme="dark"] .recharts-polar-grid line{
  stroke:rgba(148,163,184,.15) !important;
}

html[data-theme="dark"] .recharts-text{
  fill:var(--ink) !important;
}

html[data-theme="dark"] .td-table th{
  color:var(--muted) !important;
  border-color:var(--line) !important;
}

html[data-theme="dark"] .td-table td{
  color:var(--ink) !important;
  border-color:var(--line2) !important;
}

html[data-theme="dark"] .td-search{
  background:var(--paper-alt) !important;
  border-color:var(--line) !important;
  color:var(--ink) !important;
}

html[data-theme="dark"] .td-headerContent{
  background:var(--paper) !important;
  border-color:var(--line) !important;
  box-shadow:var(--shadow) !important;
}

html[data-theme="dark"] .td-pill{
  background:var(--paper-alt) !important;
  border-color:var(--line) !important;
}

html[data-theme="dark"] .td-viewIconBtn{
  background:var(--paper-alt) !important;
  border-color:var(--line) !important;
  color:var(--ink) !important;
  box-shadow:var(--shadow2) !important;
}

html[data-theme="dark"] .td-viewIconBtn:hover{
  background:rgba(181,154,91,.14) !important;
  border-color:rgba(181,154,91,.35) !important;
}

html[data-theme="dark"] .td-viewIconBtn.active,
html[data-theme="dark"] .td-viewIconBtn[aria-pressed="true"]{
  background:rgba(181,154,91,.22) !important;
  border-color:rgba(181,154,91,.5) !important;
  color:#d4b87a !important;
}

html[data-theme="dark"] .td-toolbarHint{
  color:var(--muted) !important;
}

html[data-theme="dark"] .td-modalOverlay{
  background:rgba(0,0,0,.72) !important;
}

html[data-theme="dark"] .td-modalHeader{
  border-bottom-color:var(--line) !important;
}

html[data-theme="dark"] .td-modalTitle h3,
html[data-theme="dark"] .td-modalMeta{
  color:var(--ink) !important;
}

html[data-theme="dark"] .td-backMini,
html[data-theme="dark"] .td-modalClose{
  background:rgba(22,35,28,.92) !important;
  border-color:var(--line) !important;
  color:var(--ink) !important;
  box-shadow:var(--shadow2) !important;
}

html[data-theme="dark"] .td-scopeBar{
  background:rgba(15,23,42,.88) !important;
  border-color:var(--line) !important;
}

html[data-theme="dark"] .td-drillAssetCard{
  background:rgba(22,35,28,.95) !important;
  border-color:var(--line) !important;
  box-shadow:var(--shadow) !important;
  color:var(--ink) !important;
}

html[data-theme="dark"] .td-drillAssetCard .td-num,
html[data-theme="dark"] .td-drillAssetCard div{
  color:inherit;
}

html[data-theme="dark"] .td-drillTable th{
  color:var(--muted) !important;
  border-color:var(--line) !important;
}

html[data-theme="dark"] .td-drillTable td{
  color:var(--ink) !important;
  border-color:var(--line2) !important;
}

html[data-theme="dark"] .isp-moverlay{
  background:rgba(0,0,0,.78) !important;
}

html[data-theme="dark"] .isp-mbox{
  background:linear-gradient(165deg, rgba(15,23,42,.98) 0%, rgba(22,35,28,.96) 55%, rgba(10,18,14,.98) 100%) !important;
  border-color:var(--line) !important;
  box-shadow:0 24px 64px rgba(0,0,0,.55) !important;
}

html[data-theme="dark"] .isp-mhd,
html[data-theme="dark"] .isp-mtabs,
html[data-theme="dark"] .isp-mbody,
html[data-theme="dark"] .isp-mfooter{
  background:transparent !important;
  border-color:var(--line) !important;
  color:var(--ink) !important;
}

html[data-theme="dark"] .isp-mhd h2,
html[data-theme="dark"] .isp-mhd .isp-m-title,
html[data-theme="dark"] .isp-mtab.on{
  color:var(--ink) !important;
}

html[data-theme="dark"] .isp-mtab{
  color:var(--muted) !important;
}

html[data-theme="dark"] .isp-mtab:hover{
  color:var(--ink) !important;
}

html[data-theme="dark"] .isp-fbar{
  background:rgba(15,23,42,.75) !important;
  border-color:var(--line) !important;
}

html[data-theme="dark"] .isp-fsel,
html[data-theme="dark"] .isp-fsearch{
  background:rgba(22,35,28,.9) !important;
  border-color:var(--line) !important;
  color:var(--ink) !important;
}

html[data-theme="dark"] .isp-fbar-label{
  color:var(--muted) !important;
}

html[data-theme="dark"] .isp-ct tbody td,
html[data-theme="dark"] .isp-tbl tbody td{
  color:var(--ink) !important;
  border-color:var(--line2) !important;
}

html[data-theme="dark"] .isp-ct tbody tr:hover td,
html[data-theme="dark"] .isp-tbl tbody tr:hover td{
  background:var(--row-h) !important;
}

html[data-theme="dark"] .ticker-page--dark,
html[data-theme="dark"] .ticker-page{
  color:var(--ink);
}

html[data-theme="dark"] .ticker-page .hero-main-card,
html[data-theme="dark"] .ticker-page .ticker-grid > div{
  background:var(--paper) !important;
  border-color:var(--line) !important;
}

html[data-theme="dark"] .ticker-page .back-btn{
  background:rgba(22,35,28,.75) !important;
  border-color:rgba(111,138,91,.28) !important;
  color:var(--ink) !important;
}

html[data-theme="dark"] .ticker-page .theme-fab{
  background:rgba(22,35,28,.9) !important;
  border-color:rgba(111,138,91,.35) !important;
  color:#d4b87a !important;
}
`;
